import { MeasurementInputProps } from './types'

export const MeasurementInput = ({ unit, containersProps, ...props }: MeasurementInputProps) => {
  return (
    <div className="input-container" {...containersProps}>
      <input {...props} />
      <span className="unit">{unit}</span>
    </div>
  )
}
